import React, { Component } from "react";
import firebase from "firebase/app";
import { CircleSpinner } from "react-spinners-kit";
import { withSnackbar } from "notistack";
import moment from 'moment'

import {
  Button,
  FontIcon,
  Card,
  Cell,
  Grid,
  CardActions,
  SelectionControl,
  CardTitle,
  CardText,
  TextField,
  SelectField
} from "react-md";

const style = {
  maxWidth: "960px",
  borderRadius: "5px",
  padding: "15px"
};

const avatar = {
  width: "124px",
  height: "124px",
  overflow: "hidden",
  borderRadius: "5px",
  marginBottom: "15px",
  border: "1px solid #FFFFFF",
  position: "relative"
};

const userCard = {
  border: "0",
  borderRadius: "6px",
  display: "inline-block",
  position: "relative",
  width: "100%",
  minHeight: '100%',
  marginLeft: 'auto',
  marginRight: 'auto',
  marginBottom: "20px",
  flexDirection: "column",
  minWidth: "0",
  wordWrap: "break-word",
  backgroundColor: "#fff",
  backgroundClip: "border-box"
};

const MENU_ITEMS = [
  {
    title: "50%",
    value: 50
  },
  {
    title: "45%",
    value: 45
  },
  {
    title: "40%",
    value: 40
  },
  {
    title: "35%",
    value: 35
  },
  {
    title: "30%",
    value: 30
  },
  {
    title: "25%",
    value: 25
  },
  {
    title: "20%",
    value: 20
  },
  {
    title: "15%",
    value: 15
  },
  {
    title: "10%",
    value: 10
  },
  {
    title: "5%",
    value: 5
  }
];

const PARISHES_LIST = [
  "Sandys",
  "Southampton",
  "Warwick",
  "Paget",
  "Pembroke",
  "Devonshire",
  `Smith's`,
  "Hamilton Parish",
  "St. George"
];

class Settings extends Component {
  constructor() {
    super();
    this.state = {
      isLoading: true,
      fullName: "",
      email: "",
      phone: "+1441",
      address: "",
      parish: "",
      alertPercentage: 30,
      sendSMSAlerts: false,
      sendEmailAlerts: true,
      isDisabled: true,
      photoURL: "",
      uid: "",
      sensorsCount: 0
    };
  }

  addUser = e => {
    e.preventDefault();
    firebase
      .database()
      .ref(`/storage/users/${this.state.uid}`) // Replace with user uid in the ref above
      .update(this.state)
      .then(result => {
        // Snackbar
        this.props.enqueueSnackbar("Data Saved!", { variant: "success" });
        this.setState({ isDisabled: true });
      })
      .catch(error => {
        this.props.enqueueSnackbar(error, { variant: "error" });
        console.log(error);
      });
  };

  componentDidMount() {
    const {
      uid,
      displayName,
      email,
      phoneNumber,
      photoURL,
      metadata
    } = firebase.auth().currentUser;

    if (uid) {
      firebase
        .database()
        .ref(`/storage/users/${uid}`)
        .once("value")
        .then(snap => {
          if (snap.val().photoURL && snap.val().sensors) {
            const {
              address,
              alertPercentage,
              sendEmailAlerts,
              sendSMSAlerts,
              email,
              fullName,
              parish,
              phone,
              photoURL,
              sensors,
              uid
            } = snap.val();

            this.setState({
              address,
              alertPercentage,
              sendEmailAlerts,
              sendSMSAlerts,
              email,
              fullName,
              parish,
              phone,
              photoURL,
              uid,
              metadata,
              sensorsCount: Object.values(sensors).length
            });
          } else {
            this.setState({
              uid: uid,
              fullName: displayName,
              email: email,
              phone: phoneNumber ? phoneNumber : "+1441",
              photoURL: photoURL,
              metadata
            });
          }
        })
        .then(val => {
          this.setState({ isLoading: false });
        })
        .catch(error => {
          console.log(error);
        });
    }
  }

  checkState = () => {
    this.setState({ isDisabled: !this.state.isDisabled });
  };

  render() {
    return this.state.isLoading ? (
      <div className="spinner">
        <CircleSpinner size={50} color="#2196F3" loading={this.state.spinner} />
      </div>
    ) : (
      <Grid style={{margin: 'auto'}}>
        {" "}
        <Cell size={4} phoneSize={4} tabletSize={6} tabletOffset={1}>
          <Card
            style={
              userCard
            } /*className="md-cell md-cell--4 md-cell--5-desktop"*/
          >
            <div
              style={{
                overflow: "hidden",
                height: "175px",
                position: "relative"
              }}
            >
              <img
                alt="..."
                src={"./underwater.jpg"}
                style={{ maxWidth: "100%", borderRadius: '5px' }}
              />
            </div>
            <CardText>
              <div
                style={{
                  textAlign: "center",
                  textTransform: "none",
                  marginTop: "-77px"
                }}
              >
                <img alt="..." style={avatar} src={this.state.photoURL} />
                <h5
                  style={{
                    fontWeight: 700,
                    color: "#2c2c2c",
                    textDecoration: "none"
                  }}
                >
                  {this.state.fullName}
                </h5>
                <p style={{ color: "#9a9a9a", fontWeight: 300, marginTop: '-15px' }}>
                  {this.state.email}
                </p>
                <p style={{ color: "#9a9a9a", fontWeight: 400 }}>
                  Account created at: {moment(this.state.metadata.creationTime).format('MMM Do YYYY')}
                </p>
                <p style={{ color: "#9a9a9a", fontWeight: 400,  marginTop: '-10px' }}>
                  Last sign in: {moment(this.state.metadata.lastSignInTime).format('MMM Do YYYY, hh:mma')}
                </p>
                <p
                  style={{ color: "#9a9a9a", fontWeight: 500 }}
                  className="description text-center"
                >
                  INSTALLED SENSORS
                </p>
                <p style={{color: "#9a9a9a", fontWeight: 500, fontSize: '30px'}}>
                {this.state.sensorsCount}
                </p>
              </div>
            </CardText>
          </Card>
        </Cell>
        <Cell size={8} phoneSize={8} tabletSize={8}>
          <Card
            style={style} /*className="md-cell md-cell--4 md-cell--6-desktop"*/
          >
            <CardTitle
              children={
                <FontIcon
                  style={{
                    flex: "auto",
                    textAlign: "right",
                    fontSize: "xx-large",
                    alignSelf: "flex-start"
                  }}
                >
                  settings
                </FontIcon>
              }
              className="md-divider-border md-divider-border--bottom md-text--theme-primary"
              title="Account Settings"
              subtitle="Edit your account"
            />
            <form onSubmit={this.addUser}>
              <div className="md-grid">
                <TextField
                  required
                  type="text"
                  label="Full Name"
                  name="fullName"
                  className="md-cell md-cell--4 md-cell--6-desktop"
                  onChange={val => this.setState({ fullName: val })}
                  value={this.state.fullName}
                  disabled={this.state.isDisabled}
                />
                <TextField
                  type={"email"}
                  label="Email"
                  name="email"
                  className="md-cell md-cell--4 md-cell--6-desktop"
                  required
                  onChange={val => this.setState({ email: val })}
                  value={this.state.email}
                  disabled={this.state.isDisabled}
                />
                <TextField
                  type="tel"
                  label="Phone"
                  name="phone"
                  className="md-cell md-cell--4 md-cell--6-desktop"
                  onChange={val => this.setState({ phone: val })}
                  value={this.state.phone}
                  disabled={this.state.isDisabled}
                />
                <TextField
                  type="text"
                  label="Address"
                  name="address"
                  className="md-cell md-cell--4 md-cell--6-desktop"
                  onChange={val => this.setState({ address: val })}
                  value={this.state.address}
                  disabled={this.state.isDisabled}
                />
                <SelectField
                  type="text"
                  label="Parish"
                  name="parish"
                  menuItems={PARISHES_LIST}
                  className="md-cell md-cell--4 md-cell--6-desktop"
                  onChange={val => this.setState({ parish: val })}
                  value={this.state.parish}
                  disabled={this.state.isDisabled}
                />
                <div className="md-cell md-cell--2 md-cell--3-desktop">
                  <SelectField
                    id="select-field-styling-1"
                    leftIcon={<FontIcon>notification_important</FontIcon>}
                    label="Set up tank alerts at:"
                    placeholder="Something"
                    itemLabel="title"
                    menuItems={MENU_ITEMS}
                    onChange={val => this.setState({ alertPercentage: val })}
                    helpText="Receive alerts for critical water levels."
                    value={this.state.alertPercentage}
                    disabled={this.state.isDisabled}
                  />
                </div>
                <div className="md-grid md-cell--2 md-cell--3-desktop">
                  <SelectionControl
                    primary
                    id="checkbox-sms-alerts"
                    name="smsAlerts"
                    label="SMS Alerts"
                    type="checkbox"
                    onChange={check =>
                      this.setState({
                        sendSMSAlerts: !this.state.sendSMSAlerts
                      })
                    }
                    checked={this.state.sendSMSAlerts}
                    disabled={this.state.isDisabled}
                  />
                  <SelectionControl
                    primary
                    id="checkbox-email-alerts"
                    name="emailAlerts"
                    label="Email Alerts"
                    type="checkbox"
                    onChange={check =>
                      this.setState({
                        sendEmailAlerts: !this.state.sendEmailAlerts
                      })
                    }
                    checked={this.state.sendEmailAlerts}
                    disabled={this.state.isDisabled}
                  />
                </div>
              </div>
              <CardActions className="md-divider-border md-divider-border--top">
                <Button
                  raised
                  onClick={this.checkState}
                  className="md-cell--left md-text--secondary"
                >
                  Edit
                </Button>
                <Button
                  raised
                  primary
                  type="submit"
                  className="md-cell--right"
                  disabled={this.state.isDisabled}
                >
                  Submit
                </Button>
              </CardActions>
            </form>
          </Card>
        </Cell>
      </Grid>
    );
  }
}

export default withSnackbar(Settings);
